import * as angular from 'angular';
import * as template from './template.html';
import './styling.scss';

const module = angular.module('document-download-card', []);

interface DocumentCardController extends angular.IStrictController {
    showCheckmarkOnClick: boolean;
    showCheckmark: boolean;
}

module.component('documentDownloadCard', {
    template: template,
    bindings: {
        icon: '<',
        text: '<',
        showCheckmarkOnClick: '<'
    },
    controller: function(this: DocumentCardController, $element: angular.IAugmentedJQuery) {
        'ngInject';

        this.$onInit = () => {
            if (this.showCheckmarkOnClick) {
                $element.on('click', () => {
                    this.showCheckmark = true;
                });
            }
        };
    }
});

export { module };
